import { Layout, Space } from 'antd';
import { Link } from 'react-router-dom';
import { HeartFilled } from '@ant-design/icons';

const { Footer } = Layout;

export default function FooterBar() {
  return (
    <Footer style={{ textAlign: 'center', padding: '24px 50px' }}>
      <Space direction="vertical" size="small">
        <span>React + Vite + Flask + Marshmallow (Classic) Template</span>
        <Space split="|" size="middle" style={{ fontSize: '12px' }}>
          <span>
            © {new Date().getFullYear()} with <HeartFilled style={{ color: '#ff4d4f' }} />
          </span>
          <Link to="/about">About</Link>
          <Link to="/legal">Legal</Link>
        </Space>
      </Space>
    </Footer>
  );
}
